import cqrsApiService from "@/app/shared/services/cqrsApiService.js";

export default {
  findAll(vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/TaskCategories/FindAll", undefined, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  findAllByProjectId(vm, projectId) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/TaskCategories/FindAllByProjectId", { params: { projectId }}, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  add(taskCategory, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/TaskCategories/Create", { taskCategory }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  edit(taskCategory, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/TaskCategories/Edit", { taskCategory }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  delete(id, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/TaskCategories/Delete", { id }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}